import React, { useEffect, useState } from "react";
import {
  MinusCircleOutlined,
  PlusOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import {
  Button,
  Col,
  Form,
  Image,
  Input,
  Row,
  Select,
  Space,
  Typography,
  Upload,
} from "antd";
import { useManageContentStore } from "./store";
import { CloseButton, Modal } from "react-bootstrap";
import { isImageUrl, optionsContent } from "modules/utilities/utility";
import { isEmpty } from "lodash";
const { Text } = Typography;
import { useToast } from "modules/navbar/top/store/toasterStore";

function AddContentModal({ searchText, filter }) {
  const {
    segData,
    imageData,
    imageUploadResponse,
    postLoading,
    fetchImageData,
    postImageUpload,
    fetchManageContentData,
    postManageContent,
  } = useManageContentStore();
  const [form] = Form.useForm();
  const [contentType, setContentType] = useState("default");
  const [imageUrl, setImageUrl] = useState("");
  const [file, setFile] = useState({});
  const [buttonDisabled, setIsButtonDisabled] = useState(false);
  const [imagePath, setImagePath] = useState("");
  const [backgroundImageUrl, setBackgroundImageUrl] = useState("");
  const [isImageUploading, setImageUploading] = useState(false);
  const [segmentDropDown, setSegmentDropDown] = useState([]);
  const [selectedSeg, setSelectedSeg] = useState([]);
  const [segmentData, setSegmentData] = useState("");
  const [message, setMessage] = useState("");
  const [modalShow, setModalShow] = useState(false);
  const { setToaster } = useToast();

  const BeforeUpload = (file) => {
    //commented because change of accepting file formate
    // if (file.type !== "image/jpeg") {
    // 	message.error(`only Jpeg and png image is allowed`);
    // 	return true;
    // }
    return false;
  };

  useEffect(() => {
    if (message) {
      setTimeout(() => {
        setMessage("");
      }, 1500);
    }
  }, [message]);

  useEffect(() => {
    const getSegment = async () => {
      let res = segData?.data;
      res = res?.filter((row) => row.is_active === true);
      let data = res?.map((row) => {
        return {
          label: row.display_name,
          value: row.id,
        };
      });
      setSegmentData(data);
    };
    getSegment();
  }, [segData]);

  useEffect(() => {
    if (imageData?.data) {
      setImageUrl(imageData?.data);
    }
  }, [imageData]);
  useEffect(() => {
    if (!isEmpty(imageUploadResponse)) {
      setImagePath(imageUploadResponse?.data?.imageUrl);
      fetchImageData(imageUploadResponse?.data?.imageUrl);
    }
  }, [imageUploadResponse]);

  useEffect(() => {
    setSegmentDropDown(segmentData);
  }, [segmentData]);

  const layout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 6 },
    },
    wrapperCol: {
      xs: { span: 30 },
      sm: { span: 26 },
    },
  };
  const tailLayout = {
    wrapperCol: { offset: 10 },
  };

  const handleOnSegmentChange = (value) => {
    setSelectedSeg(value);
  };

  const handleSubmit = async (submitData) => {
    const { ContentName, subject, subtext, customAttributes, article, video } =
      submitData;
    let uploadData;
    if (imagePath === "" && !(await isImageUrl(backgroundImageUrl))) {
      return setMessage("please enter image Url");
    }
    if (selectedSeg) {
      if (contentType === "default") {
        uploadData = {
          displayName: ContentName,
          subject,
          subText: subtext,
          backgroundImage: backgroundImageUrl || imagePath,
          type: contentType,
          segmentId: selectedSeg,
          customAttributes: {
            data: customAttributes,
          },
        };
      } else {
        uploadData = {
          displayName: ContentName,
          subject,
          subText: subtext,
          segmentId: selectedSeg,
          backgroundImage: backgroundImageUrl || imagePath,
          type: contentType,
          customAttributes: {
            data: customAttributes,
          },
          contentLink: video || article,
        };
      }
    } else {
      if (contentType === "default") {
        uploadData = {
          displayName: ContentName,
          subject,
          subText: subtext,
          backgroundImage: backgroundImageUrl || imagePath,
          type: contentType,
          customAttributes: {
            data: customAttributes,
          },
        };
      } else {
        uploadData = {
          displayName: ContentName,
          subject,
          subText: subtext,
          backgroundImage: backgroundImageUrl || imagePath,
          type: contentType,
          customAttributes: {
            data: customAttributes,
          },
          contentLink: video || article,
        };
      }
    }
    if (customAttributes) {
      customAttributes?.forEach((attributeOne, attributesOne) => {
        if (attributeOne.keyValue.trim() === "") {
          return setMessage("Please enter Key value");
        }

        if (
          customAttributes.some((attributeTwo, attributesTwo) => {
            return (
              attributesOne !== attributesTwo &&
              attributeOne.keyValue === attributeTwo.keyValue
            );
          })
        ) {
          return setMessage("Please use unique key's");
        }

        if (attributeOne?.value.trim() === "") {
          return setMessage("Please enter value for the key");
        }
      });
    }

    if (uploadData) {
      postManageContent(
        uploadData,
        setToaster,
        fetchManageContentData,
        filter,
        searchText,
        setModalShow
      );
    }
  };

  //file Upload
  const handleFileUpload = (info) => {
    if (info.fileList.length !== 0) {
      if (info.file.size >= 5242880) {
        return setMessage("File size should be less than or equal 5MB");
      }
      setFile(info.file);
      setIsButtonDisabled(true);
    }
  };

  const handleRemoveFile = () => {
    setIsButtonDisabled(false);
    setFile({});
  };

  const onSave = async () => {
    setImageUploading(true);
    const formData = new FormData();
    formData.append("file", file);
    postImageUpload(formData, setImageUploading);
  };

  const onDelete = () => {
    setImagePath("");
    setFile("");
    setImageUrl("");
  };

  const onSearchSegment = (val) => {
    const searchData = segmentData.filter((row) =>
      row.label?.toLowerCase().includes(val.toLowerCase().trim())
    );
    setSegmentDropDown(searchData);
    if (val.trim() === "") {
      setSegmentDropDown(searchData);
    }
  };

  const handleModalShow = () => {
    setModalShow(true);
    setImageUrl("");
  };

  const handleModalClose = () => {
    setModalShow(false);
    setContentType("default");
    form.resetFields();
    setBackgroundImageUrl("");
    setFile({});
    setImagePath("");
    setImageUrl("");
  };

  return (
    <div>
      <Button type="primary" onClick={handleModalShow}>
        Add Content
      </Button>
      <Modal
        show={modalShow}
        onHide={handleModalClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header>
          <Modal.Title id="contained-modal-title-vcenter">
            <div className="d-flex justify-content-between">
              <div>Add content</div>
              <div style={{ marginLeft: "10rem" }} className="text-warning">
                {message ? message : null}
              </div>
            </div>
          </Modal.Title>
          <CloseButton
            className="btn btn-circle btn-sm transition-base p-0"
            onClick={handleModalClose}
          />
        </Modal.Header>
        <Modal.Body
          className="scrollable-container"
          style={{ maxHeight: "82vh", overflowY: "scroll" }}
        >
          <Form {...layout} form={form} onFinish={handleSubmit}>
            <Form.Item
              label="Content Name"
              name="ContentName"
              rules={[
                { required: true, message: "Please enter content name" },
                {
                  pattern: new RegExp(/^[a-zA-Z0-9\s]+$/),
                  message: "Please enter valid name",
                },
              ]}
            >
              <Input placeholder="" />
            </Form.Item>

            <Form.Item
              label="Subject"
              name="subject"
              rules={[
                {
                  required: true,
                  message: "Please enter subject",
                },
              ]}
            >
              <Input placeholder="" />
            </Form.Item>

            <Form.Item
              label="Subtext"
              name="subtext"
              rules={[{ required: true, message: "Please enter subtext" }]}
            >
              <Input placeholder="" />
            </Form.Item>
            <Form.Item label="Select Segment" name="segmentId">
              <Select
                // mode="multiple"
                placeholder="select segments"
                style={{ width: "100%" }}
                options={segmentDropDown}
                value={selectedSeg}
                onChange={handleOnSegmentChange}
                onSearch={onSearchSegment}
                filterOption={false}
              />
            </Form.Item>
            <Form.Item
              label="Background Image URL"
              // name="image"
              rules={[
                {
                  required: imagePath === "" ? true : false,
                  message: "Please enter image URL",
                },
              ]}
            >
              <Input
                placeholder=""
                disabled={imagePath ? true : false}
                value={backgroundImageUrl}
                onChange={(event) => setBackgroundImageUrl(event.target.value)}
              />
            </Form.Item>
            {imageUrl && (
              <Col span={24} style={{ marginBottom: "30px" }}>
                <Col>
                  <Row style={{ height: "100px", marginLeft: "200px" }}>
                    <Image src={imageUrl} width={140} height={100} />
                  </Row>
                </Col>
                <Col style={{ marginLeft: "200px", marginTop: "20px" }}>
                  <Text>{imagePath}</Text>
                  <Button onClick={onDelete}>Delete</Button>
                </Col>
              </Col>
            )}
            {!imageUrl && (
              <Row justify="center" className="d-flex gap-3">
                <Form.Item>
                  <Upload
                    accept="image/jpeg,image/png"
                    beforeUpload={(file) => BeforeUpload(file)}
                    listType="picture"
                    name="file"
                    onChange={handleFileUpload}
                    onRemove={handleRemoveFile}
                    className="upload-list-inline"
                    maxCount={1}
                    disabled={backgroundImageUrl}
                  >
                    <Button
                      icon={<UploadOutlined />}
                      disabled={backgroundImageUrl}
                    >
                      Upload Image
                    </Button>
                  </Upload>
                </Form.Item>
                <Button
                  disabled={!buttonDisabled}
                  onClick={onSave}
                  loading={isImageUploading}
                >
                  Save Image
                </Button>
              </Row>
            )}

            <Form.Item
              label="Content Type"
              rules={[{ required: false, message: "Select a Content type" }]}
            >
              <Select
                allowClear
                placeholder="content type"
                value={contentType}
                defaultValue={contentType}
                onChange={(role) => {
                  setContentType(role);
                }}
                options={optionsContent}
              />
            </Form.Item>

            {contentType === "video" && (
              <Form.Item
                label="Video"
                name="video"
                rules={[{ required: true, message: "Enter video URL" }]}
              >
                <Input placeholder="video" />
              </Form.Item>
            )}
            {contentType === "article" && (
              <Form.Item
                label="Article"
                name="article"
                rules={[{ required: true, message: "Enter article URL" }]}
              >
                <Input placeholder="Article" />
              </Form.Item>
            )}
            <Form.List name="customAttributes">
              {(fields, { add, remove }) => (
                <>
                  {fields.map(({ key, name, ...restField }) => (
                    <Space
                      key={key}
                      style={{ display: "flex", marginBottom: 8 }}
                      align="baseline"
                    >
                      <Form.Item
                        {...restField}
                        name={[name, "keyValue"]}
                        rules={[{ required: true, message: "Missing Key" }]}
                        style={{ width: "230px", marginLeft: "195px" }}
                      >
                        <Input placeholder="Key" />
                      </Form.Item>
                      <Form.Item
                        {...restField}
                        name={[name, "value"]}
                        rules={[
                          {
                            required: true,
                            message: "Missing Value for the key",
                          },
                        ]}
                        style={{ marginLeft: "10px" }}
                      >
                        <Input placeholder="Value" />
                      </Form.Item>
                      <MinusCircleOutlined onClick={() => remove(name)} />
                    </Space>
                  ))}
                  <Form.Item>
                    <Row>
                      <Button
                        type="dashed"
                        onClick={() => {
                          add();
                        }}
                        block
                        style={{ marginLeft: "195px" }}
                        icon={<PlusOutlined />}
                      >
                        Add Custom Attributes
                      </Button>
                    </Row>
                  </Form.Item>
                </>
              )}
            </Form.List>

            <br />
            <Form.Item {...tailLayout}>
              <Button htmlType="submit" loading={postLoading} type="primary">
                Add Content
              </Button>
            </Form.Item>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={handleModalClose}>Close</Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default AddContentModal;
